import _ from 'lodash'
import moment from 'moment'

import i18n from '@/i18n/i18n'
import { PriceService } from '@/services/retailer/PriceService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

import { PRICE_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const namespaced = true
export const allowedFilters = ['product_name', 'product.sub_category_id', 'product.subCategory.category_id']
export const allowedIncludes = []
export const allowedSorts = []
export const allowedAppends = []

export const state = {
  products: null,
  agriInputMarketProducts: [],
  filteredAgriInputMarketProducts: [],
  cropMarketProducts: [],
  agriculturalProductsTableList: [],
  agriculturalProductsPriceArea: [],
  productsCountDown: {},
  isShowProductFilterSchemaContent: false,
  isShowEditProductList: false,
  isShowProductAddSchemaContent: false,
  notAddedBrandList: [],
  brandModal: {
    isShow: false,
    parameters: {}
  },
  isActiveSaveAllButton: false,
  isPriceRangeViolation: false
}
export const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products
  },
  SET_AGRI_INPUT_MARKET_PRODUCTS(state, products) {
    state.agriInputMarketProducts = products ?? []
  },
  SET_FILTERED_AGRI_INPUT_MARKET_PRODUCTS(state, products) {
    state.filteredAgriInputMarketProducts = products
  },
  SET_CROP_MARKET_PRODUCTS(state, products) {
    state.cropMarketProducts = products ?? []
  },
  SET_VALUE(state, data) {
    state[data.state] = data.value
  },
  SET_AGRI_INPUT_MARKET_PRODUCT(state, product) {
    const productIndex = _.findIndex(state.agriInputMarketProducts, products => {
      return products.mobile_product_id === product.mobile_product_id
    })
    if (productIndex !== -1) {
      state.agriInputMarketProducts[productIndex] = product
    } else {
      state.agriInputMarketProducts.push(product)
    }
  },
  SET_AGRICULTURAL_PRODUCTS_TABLE_LIST(state, products) {
    state.agriculturalProductsTableList = products
  },
  SET_AGRICULTURAL_PRODUCTS_PRICE_AREA(state, products) {
    state.agriculturalProductsPriceArea = products
  },
  SET_PRODUCTS_COUNT_DOWN(state, products) {
    state.productsCountDown = products
  },
  SHOW_PRODUCT_FILTER_SCHEMA_CONTENT(state, isShow) {
    state.isShowProductFilterSchemaContent = isShow
  },
  SHOW_EDIT_PRODUCT_LIST(state, isShow) {
    state.isShowEditProductList = isShow
  },
  SHOW_PRODUCT_ADD_SCHEMA_CONTENT(state, isShow) {
    state.isShowProductAddSchemaContent = isShow
  },
  SHOW_ADD_BRAND_MODAL(state, { isShow, ...parameters }) {
    state.brandModal.isShow = isShow
    state.brandModal.parameters = { ...parameters }
  },
  NOT_ADDED_BRAND_LIST(state, payload) {
    state.notAddedBrandList = payload
  },
  IS_ACTIVE_SAVE_ALL_BUTTON(state, isActive) {
    state.isActiveSaveAllButton = isActive
  },
  IS_PRICE_RANGE_VIOLATION(state, isPriceRangeViolation) {
    state.isPriceRangeViolation = isPriceRangeViolation
  }
}

export const actions = {
  getProducts({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      PriceService.getProducts()
        .then(response => {
          commit('SET_AGRI_INPUT_MARKET_PRODUCTS', response.data.agri_input_market_products)
          commit('SET_CROP_MARKET_PRODUCTS', response.data.crop_market_products)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: PRICE_ERROR_MESSAGES.getPricesError + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getProductsByQuery({ commit, dispatch, state }, query) {
    let newQuery = build_query(query, allowedFilters, allowedIncludes, allowedSorts, allowedAppends)
    return new Promise((resolve, reject) => {
      PriceService.getProductsByQuery(newQuery)
        .then(response => {
          commit('SET_FILTERED_AGRI_INPUT_MARKET_PRODUCTS', response.data.agri_input_market_products)
          commit('SET_CROP_MARKET_PRODUCTS', response.data.crop_market_products)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: PRICE_ERROR_MESSAGES.getPricesError + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  savePrices({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      let prices = _.sortBy(params, product => {
        return product.price
      })
      PriceService.savePrices({ prices: prices.reverse() })
        .then(response => {
          commit('SET_AGRI_INPUT_MARKET_PRODUCTS', response.data.agri_input_market_products)
          commit('SET_CROP_MARKET_PRODUCTS', response.data.crop_market_products)
          commit('retailerAuth/SET_LATEST_PRICE_DATE', moment().format(), {
            root: true
          })

          const notification = {
            type: 'success',
            message: t('store.retailer.price.prices_saved')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: PRICE_ERROR_MESSAGES.savePricesError + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  savePrice({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      PriceService.savePrice({ prices: params })
        .then(response => {
          commit('SET_AGRI_INPUT_MARKET_PRODUCT', response.data)

          const notification = {
            type: 'success',
            message: t('store.retailer.price.price_saved')
          }
          dispatch('notification/add', notification, {
            root: true
          })

          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: PRICE_ERROR_MESSAGES.savePriceError + ' ' + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateProducts({ commit }, params) {
    commit('SET_VALUE', params)
  }
}
